import { CodexDTO } from '../schemas';
import type { Codex } from '@/lib/types';

/**
 * Maps a CodexDTO to the domain Codex model.
 */
export function mapCodexDTOToDomain(dto: CodexDTO): Codex {
  const { details, ...codex } = dto;

  return {
    ...details,
    ...codex,
    id: dto.id || '', // Ensure ID is present
  } as Codex;
}

/**
 * Maps an array of CodexDTOs to domain Codex entries.
 */
export function mapCodexesDTOToDomain(dtos: CodexDTO[]): Codex[] {
  return dtos.map(mapCodexDTOToDomain);
}
